import { PipesModule } from './../pipes/pipes.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {MatDialogModule} from '@angular/material/dialog';
import { TicketDetailsComponent } from './ticket-details/ticket-details.component';
import { MessageBoxComponent } from './message-box/message-box.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { PartnerBonusSelectComponent } from './partner-bonus-select/partner-bonus-select.component';
import { BonusAlertComponent } from './dialogues/bonus-alert/bonus-alert.component';
import { RouterModule } from '@angular/router';
import { UserMessageBoxComponent } from './dialogues/user-message-box/user-message-box.component';
import { DialogFormBoxComponent } from './dialogues/dialog-form-box/dialog-form-box.component';
import { SelectLoadingComponent } from './select-loading/select-loading.component';
import { KycLoaderComponent } from './kyc-loader/kyc-loader.component';


@NgModule({
  declarations: [
   TicketDetailsComponent,
   MessageBoxComponent,
   SidebarComponent,
   PartnerBonusSelectComponent,
   BonusAlertComponent,
   UserMessageBoxComponent,
   DialogFormBoxComponent,
   SelectLoadingComponent,
   KycLoaderComponent,
  ], exports: [SidebarComponent, PartnerBonusSelectComponent, SelectLoadingComponent, KycLoaderComponent],
  entryComponents: [TicketDetailsComponent,MessageBoxComponent, BonusAlertComponent, UserMessageBoxComponent, DialogFormBoxComponent],
  imports: [
    TranslateModule.forChild(),
    CommonModule,
    PipesModule,
    RouterModule,
    FormsModule,
    MatDialogModule,
    ReactiveFormsModule
  ]
})
export class ComponentsModule { }
